<div class="row">
  <div class="col-12 matris-header">
    <h5>Produktionsmål i m3f</h5>
  </div>
  <div class="col-12">
    @if (hot) {
      <rask-hot-doc
        [hotDoc]="hot">
      </rask-hot-doc>
    }
  </div>
</div>
